import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { bind, formatCurrency, isNil } from 'vdlib';
import EntityGroupReport from './EntityGroupReport';

const createGroups = () => [
  { ID: 'All', Description: I.t('ALL') },
  { ID: 'PerInsurance', Description: I.t('PER_INSURANCE') },
  { ID: 'PerBrand', Description: I.t('PER_BRAND') },
  { ID: 'PerRegion', Description: I.t('PER_REGION') },
  { ID: 'PerPartType', Description: I.t('PER_PART_TYPE') },
];

class MerchantReports extends React.Component {
  constructor(props) {
    super(props);
    bind(this, ['populate']);
    this.groups = createGroups();
    this.populate(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang !== nextProps.lang) this.groups = createGroups();
    this.populate(nextProps);
  }

  populate(props) {
    if (isNil(props)) props = this.props;

    this.groupEntities = {
      PerInsurance: {
        title: I.t('INSURANCES'),
        empty: I.t('REPORT_NO_INSURANCE'),
        data: this.props.insurances,
      },
      PerBrand: { title: I.t('BRANDS'), empty: I.t('REPORT_NO_BRAND') },
      PerRegion: {
        title: I.t('REGIONS'),
        empty: I.t('REPORT_NO_REGION'),
        data: this.props.regions,
      },
      PerPartType: {
        title: I.t('PART_TYPES'),
        empty: false,
        data: this.props.partTypes,
      },
    };
  }

  render() {
    return (
      <div>
        <EntityGroupReport
          data={this.props.generalData}
          groupMembers={this.groups}
          groupEntities={this.groupEntities}
          buttonsColor="green"
          fetching={this.props.fetchingGeneralData}
          fetchData={this.props.fetchGeneralData}
          defaultDataMember="TotalAuctions"
          dataMembers={[
            { ID: 'TotalAuctions', Description: I.t('AUCTIONS') },
            {
              ID: 'TotalAmount',
              Description: I.t('AMOUNTS'),
              valueParser: formatCurrency,
            },
            { ID: 'Wins', Description: I.t('WINS') },
            { ID: 'Losses', Description: I.t('LOSES') },
          ]}
          lang={this.props.lang}
        />
      </div>
    );
  }
}

export default MerchantReports;
